import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { MtTable } from 'src/app/modules/core/classes/mt-table';
import { IMarineLoop } from '../../../interfaces/marine-loop';

@Component({
  selector: 'app-details-table-marine',
  templateUrl: './details-table-marine.component.html',
  styleUrls: ['./details-table-marine.component.scss']
})
export class DetailsTableMarineComponent {

  @Input()
  public marineLoops: IMarineLoop[];

}
